module.exports = __webpack_public_path__ + "4c504db8a098be959c2bcea18dda9e41.pdf";